import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { serializeClasses } from 'utilities/css';

const Path = styled.path`
  fill: ${({ theme }) => theme.colors.accentGray03};
  &.active {
    fill: ${({ theme }) => theme.colors.accentGray04};
  }
`;

export const ListIcon = ({ className, active, ...rest }) => {
  const pathClass = serializeClasses([active && 'active']);
  return (
    <svg
      {...rest}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
    >
      <g fill="none" fillRule="evenodd">
        <g
          transform="translate(-1324.000000, -211.000000) translate(1318.000000, 205.000000) translate(6.000000, 6.000000)"
        >
          <Path
            className={pathClass}
            fillRule="nonzero"
            d="M18.889 19.444H6.667c-.614 0-1.111-.497-1.111-1.11 0-.614.497-1.112 1.11-1.112H18.89c.614 0 1.111.498 1.111 1.111 0 .614-.497 1.111-1.111 1.111zm0-5.555H6.667c-.614 0-1.111-.498-1.111-1.111 0-.614.497-1.111 1.11-1.111H18.89c.614 0 1.111.497 1.111 1.11 0 .614-.497 1.112-1.111 1.112zm0-5.556H6.667c-.614 0-1.111-.497-1.111-1.11 0-.614.497-1.112 1.11-1.112H18.89c.614 0 1.111.498 1.111 1.111 0 .614-.497 1.111-1.111 1.111zm0-5.555H6.667c-.614 0-1.111-.498-1.111-1.111 0-.614.497-1.111 1.11-1.111H18.89c.614 0 1.111.497 1.111 1.11 0 .614-.497 1.112-1.111 1.112zM0 6.667c0-.614.497-1.111 1.111-1.111h1.111c.614 0 1.111.497 1.111 1.11v1.112c0 .613-.497 1.11-1.11 1.11H1.11C.497 8.889 0 8.392 0 7.779V6.667zm1.111 10h1.111c.614 0 1.111.497 1.111 1.11v1.112c0 .614-.497 1.111-1.11 1.111H1.11C.497 20 0 19.503 0 18.889v-1.111c0-.295.117-.578.325-.786.209-.208.491-.325.786-.325zM0 12.222c0-.613.497-1.11 1.111-1.11h1.111c.614 0 1.111.497 1.111 1.11v1.111c0 .614-.497 1.111-1.11 1.111H1.11c-.614 0-1.111-.497-1.111-1.11v-1.112zm3.333-10c0 .614-.497 1.111-1.11 1.111H1.11C.497 3.333 0 2.836 0 2.223V1.11C0 .497.497 0 1.111 0h1.111c.614 0 1.111.497 1.111 1.111v1.111z"
            transform="translate(0.000000, 0.000000)"
          />
        </g>
      </g>
    </svg>
  );
};

ListIcon.propTypes = {
  className: PropTypes.string,
  active: PropTypes.bool,
};

ListIcon.defaultProps = {
  className: undefined,
  active: false,
};
